module.exports = __webpack_public_path__ + "4f1aa7f33222b106391e29c5df19ac85.png";